import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import SpellCheckInputContainer from '../inputs/SpellCheckInputContainer';
import Audios from '../inputs/Audios';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import NativeSpeechSlice from '../inputs/NativeSpeechSlice';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const VocabularyItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Vocabulary"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          description={get(props.errors, 'text', '')}
          fieldValidation={get(props.errors, 'text', null) && 'error'}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Image Prompt"
          fieldType="textarea"
          textAreaRows="4"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'imagePrompt', '')}
          onChange={(value) => props.onChange('imagePrompt', value)}
          errorText={get(props.errors, 'imagePrompt', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={4}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      <Column size={4}>
        <LocalFileInput
          label="Upload an image to the item"
          accept="image"
          cropSize={{ width: 960, height: 640 }}
          disabled={props.disabled}
          value={get(props.values, 'image', '')}
          onChange={(key) => props.onChange('image', key)}
          errorText={get(props.errors, 'image', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Post Phrase"
          disabled={props.submitting}
          value={get(props.values, 'postPhrase', '')}
          onChange={(value) => props.onChange('postPhrase', value)}
          description={get(props.errors, 'postPhrase', '')}
          fieldValidation={get(props.errors, 'postPhrase', null) && 'error'}
          errorText={get(props.errors, 'postPhrase', '')}
        />
      </Column>
      <Column size={12}>
        <SpellCheckInputContainer
          onChange={props.onChange}
          submitting={props.submitting}
          values={props.values}
          textPath="postPhrase"
          disabled={props.disabled}
        />
      </Column>
    </Row>
    {props.hasPostPhraseImage && (
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="Post Phrase Image Prompt"
            fieldType="textarea"
            textAreaRows="4"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'postPhraseImagePrompt', '')}
            onChange={(value) => props.onChange('postPhraseImagePrompt', value)}
            errorText={get(props.errors, 'postPhraseImagePrompt', '')}
          />
        </Column>
      </Row>
    )}
    <Row>
      <Column size={6}>
        <Audios
          label="post phrase"
          audioPath="postPhraseAudio"
          generatedAudioPath="generatedPostPhraseAudio"
          values={props.values}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      {props.hasPostPhraseImage && (
        <Column size={4}>
          <LocalFileInput
            label="Upload an image to the post phrase"
            accept="image"
            cropSize={{ width: 960, height: 640 }}
            disabled={props.disabled}
            value={get(props.values, 'postPhraseImage', '')}
            onChange={(key) => props.onChange('postPhraseImage', key)}
            errorText={get(props.errors, 'postPhraseImage', '')}
          />
        </Column>
      )}
    </Row>
    <TranslationInputContainer
      onChange={props.onChange}
      submitting={props.submitting}
      values={props.values}
      errors={props.errors}
      disabled={props.disabled}
    />

    {!!get(props.values, 'id') && (
      <NativeSpeechSlice
        disabled={props.disabled}
        submitting={props.submitting}
        values={props.values}
        onRefreshNativeSpeechRecognition={props.onRefreshNativeSpeechRecognition}
        audioPath="postPhraseAudio"
      />
    )}
  </div>
);

VocabularyItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onRefreshNativeSpeechRecognition: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  hasPostPhraseImage: PropTypes.bool,
};

VocabularyItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
};

export default VocabularyItemForm;
